import React, { useCallback, useState, useImperativeHandle } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { DateContainerDiv } from '../../../ReportBuilder/Components/SectionDate';
import { formattedDate } from 'shared/utils/date';
import { CalendarContainer } from '../../../ReportBuilder/styles';
import { LocalizationProvider, CalendarPicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { createDate } from 'shared/utils/formatUTC';

const StyledDiv = styled(DateContainerDiv)`
  .show-selected-date {
    max-width: 312px;
  }
`;

const DateSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(({ reportId, questionId, questionText, answer }, forwardRef) => {
  const [date, setDate] = useState<Date | undefined>(
    answer ? createDate(answer) : undefined,
  );

  const handleDate = useCallback(
    (date: Date | null) => {
      date && setDate(date);
    },
    [setDate],
  );

  useImperativeHandle(forwardRef, () => ({
    reportId,
    questionId,
    answer: () => formattedDate(date) || '',
    errorText: () => (date ? undefined : 'Please pick a valid date.'),
  }));

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledDiv>
        <TrueImpactText variant="heading-subheading" className="question-text">
          {questionId === 10006 ? 'Planning Start Date:' : questionText}
        </TrueImpactText>
        <div className="show-selected-date">
          <div>{formattedDate(date) || 'Please select a date below'}</div>
          <FontAwesomeIcon icon={faCalendar} />
        </div>
        <CalendarContainer className="show-cn-calendar">
          <CalendarPicker date={date || new Date()} onChange={handleDate} />
        </CalendarContainer>
      </StyledDiv>
    </LocalizationProvider>
  );
});

export default DateSection;
